// Shared layout for the About, Contact, Help, Terms and Privacy pages:
// image hero, page content, closing "book a ride" band, footer.
import React from 'react';
import { PiArrowRight, PiPhone } from 'react-icons/pi';
import SiteHeader from '../SiteHeader';
import SiteFooter from '../SiteFooter';
import { usePageMeta, useReveal } from '../hooks';
import { Button, Container, Eyebrow } from '../ui';
import { CONTAINER_WIDTH, HeroImage, siteImage } from '../images';
import './pages.css';

export const PHONE_DISPLAY = '+1 929-231-5951';
export const PHONE_HREF = 'tel:+19292315951';
export const EMAIL = 'service@rooldrive.com';

export function PageHero({ image, eyebrow, title, lead, children }) {
  return (
    <section className={`pg-hero${image ? '' : ' pg-hero--plain'}`}>
      {image && (
        <div className="pg-hero-media">
          <HeroImage name={image} />
        </div>
      )}
      <Container>
        <div className="pg-hero-content">
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <h1 className="lx-h1">{title}</h1>
          {lead && <p className="lx-lead">{lead}</p>}
          {children}
        </div>
      </Container>
    </section>
  );
}

export function BookBand({ title = <>Where can we <em>take you</em>?</>, image = 'williamsburg-bridge-dusk' }) {
  return (
    <section className="lx-section">
      <Container>
        <div className="pg-band lx-reveal">
          <img {...siteImage(image, CONTAINER_WIDTH)} alt="" loading="lazy" />
          <div className="pg-band-content">
            <Eyebrow>Ready when you are</Eyebrow>
            <h2 className="lx-h2">{title}</h2>
            <div className="pg-actions pg-actions--center">
              <Button to="/book" size="lg" iconAfter={PiArrowRight}>Book a ride</Button>
              <Button href={PHONE_HREF} variant="secondary" size="lg" icon={PiPhone}>{PHONE_DISPLAY}</Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default function InfoPage({ title, description, hero, children, band = true }) {
  usePageMeta(title, description);
  const revealRef = useReveal();
  return (
    <div className="lx-page" ref={revealRef}>
      <SiteHeader overlay />
      <main>
        {hero}
        {children}
        {band && <BookBand />}
      </main>
      <SiteFooter />
    </div>
  );
}
